import {UserDto} from "../../Core/Schema/models/UserDto";
import styles from './ManageUserRow.module.css'

export const ManageUserRow = ({ user }: { user: UserDto }) => {
    return (
        <div className={styles.user_row}>
            <div style={{ textDecoration: user.disabled ? 'line-through' : 'none' }}>{user.name}</div>
        </div>
    )
}